module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_030.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_030.png
// module id = 2377
// module chunks = 5